var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.374,
    height: 50.385,
    viewBox: "0 0 86.374 50.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13377",
    d: "M7.89 12.144a3.5 3.5 0 0 1 0-5.09 3.859 3.859 0 0 1 5.3 0c7.282 6.992 17.4 6.992 24.684 0a3.859 3.859 0 0 1 5.3 0 3.5 3.5 0 0 1 0 5.09c-10.207 9.803-25.074 9.803-35.284 0z",
    transform: "translate(17.654 15.594)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13378",
    d: "M1.589 21.211a5.783 5.783 0 0 0 0 7.964c6.525 7.1 21.962 21.211 41.6 21.211s35.073-14.11 41.6-21.211a5.783 5.783 0 0 0 0-7.964C78.26 14.11 62.823 0 43.187 0S8.114 14.11 1.589 21.211zM43.187 7.2c-15.535 0-28.627 11-35.248 17.995 6.622 6.991 19.713 17.995 35.248 17.995s28.627-11 35.249-17.995C71.814 18.2 58.722 7.2 43.187 7.2z",
    style: {
      fill: "#abafd1",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.3ac178c68ce9a03c2aafbd221e05cb03.svg";
export { ForwardRef as ReactComponent };